// extracted by mini-css-extract-plugin
export var SiteHeader = "SiteHeader-module--SiteHeader--35f31";
export var location = "SiteHeader-module--location--53f9f";